import dayjs from 'dayjs'
import highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import styled from 'styled-components'

export interface LineDataObject {
  name: string
  data: number[]
}

interface LineChartProps {
  title?: string
  subTitle?: string
  xAxisLabel?: string
  yAxisLabel?: string
  data?: LineDataObject[]
  colors?: string[]
  startDate?: string
  endDate?: string
  displayLegend?: boolean
  dateFrame?: string
  tooltipFormatter?: () => void
  'data-testid'?: string
}

export const LineChart = ({
  title,
  subTitle,
  xAxisLabel,
  yAxisLabel,
  data,
  colors,
  startDate,
  endDate,
  displayLegend = false,
  dateFrame = 'week',
  tooltipFormatter,
  'data-testid': testId
}: LineChartProps) => {
  const chartStartDate =
    dateFrame === 'week'
      ? dayjs(startDate).valueOf()
      : dayjs(startDate).startOf('month').valueOf()
  const chartEndDate =
    dateFrame === 'week'
      ? dayjs(endDate).valueOf()
      : dayjs(endDate).endOf('month').valueOf()

  const pointInterval =
    dateFrame === 'week'
      ? dayjs().add(1, 'week').diff(dayjs(), 'millisecond')
      : dayjs().add(1, 'month').diff(dayjs(), 'millisecond')

  const config = {
    title: {
      text: title,
      align: 'left'
    },

    subtitle: {
      text: subTitle,
      align: 'left'
    },
    yAxis: {
      title: {
        text: yAxisLabel
      }
    },
    xAxis: {
      type: 'datetime',
      title: {
        text: xAxisLabel
      },
      labels: {
        style: {
          color: 'black',
          background: 'red'
        }
      },
      min: chartStartDate,
      max: chartEndDate,
      endOnTick: true
    },
    chart: {
      height: 350,
      type: 'spline'
    },
    tooltip: {
      valueDecimals: 0,
      formatter: tooltipFormatter
    },
    plotOptions: {
      series: {
        borderWidth: 0,
        pointStart: chartStartDate,
        pointEnd: chartEndDate,
        pointInterval
      }
    },
    credits: {
      enabled: false
    },
    colors,
    legend: {
      enabled: displayLegend
    },
    series: data
  }
  return (
    <Container data-testid={testId}>
      <HighchartsReact highcharts={highcharts} options={config} />
    </Container>
  )
}

export default LineChart

const Container = styled.div`
  border-radius: 25px;
  background-size: 90%;
  background-position-x: 35%;
  background-position-y: center;
  background-repeat: no-repeat;

  ${({ theme }) => theme.mediaQueries.mobileDown} {
    background-size: 250%;
    background-position-x: 5%;
    background-position-y: bottom;
  }
`
